var fitt = require('fitt');

/**
                             * 	Wrapped promise that allows for canceling of initiated requests
                             *
                             * @name {Object} Canceler
                             * @constructor
                             * @public
                             */

function Canceler() {
	// Internal methods to resolve promise
	this.cancel = null;

	this.promise = new Promise(function (resolve, reject) {
		/**
                                                         * @name Canceler.cancel
                                                         * @instance
                                                         * @param {String | Object} - object that gets passed through to caller's catch function
                                                         */
		this.cancel = resolve;
	}.bind(this));
	Object.freeze(this);
}

if (typeof module !== fitt.TYPE_UNDEF) {
	module.exports = Canceler;
}


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-http/core/canceler.js
// module id = 824
// module chunks = 0